<template>
  <div>
    <template v-if="selectCampaign">
      <div :key="selectCampaign.id">
        <v-tabs
          v-model="viewPage"
          color="white"
          :slider-color="$vuetify.theme.primary"
          style="font-size: 18px"
          show-arrows
        >
          <v-tab
            v-for="(item, index) in filterdMenuItem"
            :key="`menu-item-${index}`"
            style="text-transform: capitalize"
            ripple
            :href="`#${item.view}`"
            @click="updateSlug(item.view)"
            >{{ item.text }}</v-tab
          >
        </v-tabs>

        <v-container class="mt-4" fluid>
          <component :is="getComponentName(view)"></component>
        </v-container>
      </div>
    </template>
    <template v-else>
      <v-layout fill-height align-center justify-center ma-0>
        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
      </v-layout>
    </template>
  </div>
</template>

<script>
import Ecoupon from './Ecoupon'
// import Member from './Member'
import Branch from './Branch'
import Product from './Product'
import ApproveReceipt from './ApproveReceipt'
// import Campaign from './Campaign'
import Reward from './Reward'
import Approvereward from './Approvereward'
import SendingReward from './SendingReward/main.vue'
import TopCustomer from './TopCustomer'
import TopStore from './TopStore'
import ExportCustomerAndStore from './ExportCustomerAndStore'
import AnnounceLucky from './AnnounceLucky'
import ToaMegaPaintBranch from './ToaMegaPaintBranch'
import ToaMegaPaintManageEcoupon from './ToaMegaPaintManageEcoupon'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    Ecoupon,
    // Member,
    Branch,
    Product,
    ApproveReceipt,
    // Campaign,
    Reward,
    Approvereward,
    SendingReward,
    TopCustomer,
    TopStore,
    ExportCustomerAndStore,
    AnnounceLucky,
    ToaMegaPaintBranch,
    ToaMegaPaintManageEcoupon
  },
  data() {
    return {
      viewPage: 'approveReceipt',
      menuItem: [
        // full,collect,lucky_draw
        // {
        //   text: 'ข้อมูลสมาชิก',
        //   view: 'member'
        // },
        {
          text: 'จัดการร้านค้า',
          view: 'store',
          type: ['full', 'collect', 'lucky_draw']
        },
        {
          text: 'จัดการสินค้า',
          view: 'product',
          type: ['full', 'collect', 'lucky_draw']
        },
        {
          text: 'การอนุมัติใบเสร็จ',
          view: 'approveReceipt',
          type: ['full', 'collect', 'lucky_draw']
        },

        // {
        //   text: 'จัดการแคมเปญ',
        //   view: 'campaign'
        // },
        {
          text: 'Top ลูกค้า',
          view: 'topCustomer',
          type: ['lucky_draw']
        },
        {
          text: 'Top ร้านค้า',
          view: 'topStore',
          type: ['lucky_draw']
        },
        {
          text: 'รายชื่อลูกค้าและร้านค้า',
          view: 'exportCustomerAndStore',
          type: ['lucky_draw']
        },
        {
          text: 'แจ้งผลผู้โชคดี',
          view: 'announceLucky',
          type: ['lucky_draw']
        },
        {
          text: 'จัดการของรางวัล',
          view: 'reward',
          type: ['collect', 'lucky_draw']
        },
        {
          text: 'อนุมัติของรางวัล',
          view: 'approvereward',
          type: ['collect', 'lucky_draw']
        },
        {
          text: 'จัดส่งของรางวัล',
          view: 'SendingReward',
          type: ['collect', 'lucky_draw']
        },
        {
          text: 'การใช้คูปอง',
          view: 'ecoupon',
          type: ['full', 'collect', 'lucky_draw']
        }
      ]
    }
  },
  async mounted() {
    if (
      PAGE &&
      PAGE.TOA_MEGA_PAINT &&
      this.selectedBot &&
      this.selectedBot.pageid &&
      PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)
    ) {
      const tabBranch = {
        text: 'จัดการสาขา',
        view: 'ToaMegaPaintBranch',
        type: ['full', 'collect', 'lucky_draw']
      }
      this.menuItem.splice(1, 0, tabBranch)
      this.menuItem.push({
        text: 'จัดการคูปอง',
        view: 'ToaMegaPaintManageEcoupon',
        type: ['full', 'collect', 'lucky_draw']
      })
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    selectCampaign() {
      return this.$store.state.selectToaCampaign
    },
    filterdMenuItem() {
      let menulist = _.cloneDeep(this.menuItem).filter((item) =>
        this.selectedBot.type === 'toa-megapaint' ? item.view !== 'ecoupon' : true
      )
      if (this.selectCampaign) {
        menulist = menulist.filter((el) => {
          return el.type.includes(this.selectCampaign.type)
        })
      }
      return menulist
      // if (this.$store.state.privilege && this.$store.state.privilege.role) {
      //   var role = this.$store.state.privilege.role
      //   if (role == 'superadmin') return this.menuItem
      //   else if (role == 'admin') {
      //     // return this.menuItem.filter((el) => !['point'].includes(el.view))
      //     return this.menuItem
      //   } else if (['manager', 'accounting'].includes(role)) {
      //     return this.menuItem.filter((el) =>
      //       ['ApproveReceipt', 'status', 'member'].includes(el.view)
      //     )
      //   }
      // } else {
      //   return this.menuItem
      // }
    },
    view() {
      let view = this.getDefaultView()
      return view
    }
  },
  methods: {
    getDefaultView() {
      let defaultMenu = 'approveReceipt'
      var result = this.$route.query.view ? this.$route.query.view : defaultMenu
      if (this.filterdMenuItem.some((el) => el.view == result)) {
        this.viewPage = result
        return result
      } else {
        this.viewPage = defaultMenu
        return defaultMenu
      }
    },
    getComponentName(view) {
      switch (view) {
        case 'member':
          return 'member'
        case 'store':
          return 'branch'
        case 'product':
          return 'product'
        case 'approveReceipt':
          return 'approve-receipt'
        case 'ecoupon':
          return 'ecoupon'
        case 'reward':
          return 'reward'
        case 'campaign':
          return 'campaign'
        case 'approvereward':
          return 'approvereward'
        case 'SendingReward':
          return 'sending-reward'
        case 'topCustomer':
          return 'top-customer'
        case 'topStore':
          return 'top-store'
        case 'exportCustomerAndStore':
          return 'export-customer-and-store'
        case 'announceLucky':
          return 'announce-lucky'
        case 'ToaMegaPaintBranch':
          return 'ToaMegaPaintBranch'
        case 'ToaMegaPaintManageEcoupon':
          return 'ToaMegaPaintManageEcoupon'
      }
    },
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    }
  },
  watch: {
    selectCampaign(newVal) {
      if (newVal) {
        let view = this.getDefaultView()
        this.updateSlug(view)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/main.vue